var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar-wrapper"},[_c('div',{staticClass:"progressbar",class:_vm.progressBarType,style:([_vm.progressBarValue])})])
}
var staticRenderFns = []

export { render, staticRenderFns }